import React, { useEffect, useRef, useState } from "react";

const MapsAddress = ({ onChange, value, noLabel = true, disabled = false, showAsterisk = true}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [inputValue, setInputValue] = useState(value?.address || "");

  useEffect(() => {
    if (!window.google?.maps?.places || !inputRef.current) return;

    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current
    );

    autocompleteRef.current.addListener("place_changed", () => {
      const place = autocompleteRef.current.getPlace();
      if (!place?.geometry?.location || !place?.formatted_address) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const address = place.formatted_address;

      onChange({ lat, lng, address });
    });

    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current
        );
      }
    };
  }, [onChange]);

  useEffect(() => {
    if (value?.address !== undefined && value.address !== inputValue) {
      setInputValue(value.address);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value?.address]);

  const handleInputChange = (e) => {
    const newAddress = e.target.value;
    setInputValue(newAddress);
  };

  return (
    <div>
      {noLabel ? (
        <span style={{ fontSize: "14px" }}>
          Address{showAsterisk ? <span style={{ color: "red" }}>*</span> : null}
        </span>
      ) : null}
      <input
        disabled={disabled}
        className="input-class-map"
        ref={inputRef}
        type="text"
        placeholder="Enter address"
        value={inputValue}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default MapsAddress;
